"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizeExam = exports.examAuthEngine = exports.CalculateExamAuthorizationId = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const mxp_schemas_1 = require("mxp-schemas");
class CalculateExamAuthorizationId {
    constructor(examAuthID, qualificationLevelStatus, type, examExemption) {
        this.operationType = [
            mxp_schemas_1.User.QualificationLevelStatus.Suspended,
            mxp_schemas_1.User.QualificationLevelStatus.Locked,
            mxp_schemas_1.User.QualificationLevelStatus.NotApplicable,
        ].includes(qualificationLevelStatus)
            ? 'Delete'
            : type;
        this.examAuthID = examAuthID;
        this.eadAction = [];
        this.examBookingCancelActions = [];
        switch (this.operationType.toUpperCase()) {
            case 'CREATE':
            case 'CREATED':
                // if exam auth has person exam exemption approve, deauthorize exiting PV ead, and update Exam auth as exempted
                if (examExemption === mxp_schemas_1.SalesforceResponses.PersonExamExemptionStatus.Approved) {
                    this.operation = mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE;
                    this.examAuthStatus = mxp_schemas_1.SalesforceResponses.ExamAuthStatus.EXEMPTED;
                }
                else {
                    this.operation = mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.ADD;
                    this.examAuthStatus = mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE;
                }
                break;
            case 'UPDATE':
            case 'UPDATED':
                this.operation = mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.UPDATE;
                // if exam auth has person exam exemption approve, deauthorize exiting PV ead, and update Exam auth as exempted
                if (examExemption === mxp_schemas_1.SalesforceResponses.PersonExamExemptionStatus.Approved) {
                    this.operation = mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE;
                    this.examAuthStatus = mxp_schemas_1.SalesforceResponses.ExamAuthStatus.EXEMPTED;
                }
                else {
                    this.examAuthStatus = mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE;
                }
                break;
            case 'DELETE':
            case 'DELETED':
                this.examAuthStatus =
                    examExemption === mxp_schemas_1.SalesforceResponses.PersonExamExemptionStatus.Approved
                        ? mxp_schemas_1.SalesforceResponses.ExamAuthStatus.EXEMPTED
                        : mxp_schemas_1.SalesforceResponses.ExamAuthStatus.LOCKED;
                this.operation = mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE;
                break;
        }
    }
    process() {
        const filterExamAuth = this.eadAction.filter((pvEAD) => {
            // Only update and delete if authorizationId and clientAuthID exists
            return ((['Update', 'Delete'].includes(pvEAD.authorizationTransactionType) &&
                ((pvEAD === null || pvEAD === void 0 ? void 0 : pvEAD.authorizationID) || (pvEAD === null || pvEAD === void 0 ? void 0 : pvEAD.clientAuthorizationID))) ||
                pvEAD.authorizationTransactionType === 'Add');
        });
        if ([mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE, mxp_schemas_1.SalesforceResponses.ExamAuthStatus.EXEMPTED].includes(this.examAuthStatus)) {
            // Only Locked, if pv eads dont have pv EAD for Add/Update and its not from booking cancellation!
            if (!filterExamAuth.some(e => {
                return ['Add', 'Update'].includes(e.authorizationTransactionType);
            }) &&
                this.examBookingCancelActions.length === 0) {
                this.examAuthStatus = mxp_schemas_1.SalesforceResponses.ExamAuthStatus.LOCKED;
            }
        }
        return {
            examAuthID: this.examAuthID,
            action: this.operation,
            examAuthRecords: filterExamAuth,
            examAuthStatus: this.examAuthStatus,
            examBookingCancelActions: this.examBookingCancelActions,
            examCreditAction: this.examCreditAction,
            examCreditJunctionActions: this.examCreditJunctionActions,
            examSpecialAccommodationJunctionActions: this.examSpecialAccommodationJunctionActions,
            personSpecialAccommodationExamAuthJunctionActions: this.personSpecialAccommodationExamAuthJunctionActions,
            authorizeDate: this.authorizeDate,
        };
    }
}
exports.CalculateExamAuthorizationId = CalculateExamAuthorizationId;
const examAuthEngine = (candidate, baseExamAuth, operationType, log, subscriptionEndDate, subscriptionStartDate) => {
    var _a, _b;
    log.debug(`candidate: ${JSON.stringify(candidate)}`);
    log.debug(`baseExamAuth: ${JSON.stringify(baseExamAuth)}`);
    log.debug(`operationType: ${JSON.stringify(operationType)}`);
    if (subscriptionEndDate) {
        log.info(`examAuthEngine: FLP subscriptionEndDate=${subscriptionEndDate} for examAuth=${baseExamAuth.examAuth.id}`);
    }
    const { examAuth, examCredit, specialAccommodation, examList, examBooking, examResult } = baseExamAuth;
    const { pvExamAuth, examCreditJunction, specialAccommodationJunction } = examAuth;
    // if no pv exam auth to update, lets create pv exam auth
    const examAuthorization = new CalculateExamAuthorizationId(examAuth.id, candidate === null || candidate === void 0 ? void 0 : candidate.qualificationLevelStatus, operationType === 'Update' &&
        (pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.filter(item => {
            return item.status === mxp_schemas_1.PearsonVue.EXAM_AUTH_STATUS.ACTIVE;
        }).length) === 0
        ? 'Create'
        : operationType, baseExamAuth.examExemption);
    // if exam result ratification status ratified
    if ((examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_RatificationStatus__c) === mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.ratified &&
        [mxp_schemas_1.SalesforceResponses.ExamAuthStatus.CONSUMED_RESULT_NOT_PUBLISHED].includes(examAuth === null || examAuth === void 0 ? void 0 : examAuth.status)) {
        performUsedExamCredit(baseExamAuth, examAuthorization, log);
        if ([
            mxp_schemas_1.PearsonVue.ExamResultOverrideStatus.misconduct,
            mxp_schemas_1.PearsonVue.ExamResultOverrideStatus.technicalError,
            mxp_schemas_1.PearsonVue.ExamResultOverrideStatus.voided,
        ].includes(examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_OverrideStatus__c)) {
            examAuthorization.examAuthStatus = isExamAuthLocked(candidate === null || candidate === void 0 ? void 0 : candidate.qualificationLevelStatus, mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE);
        }
    }
    // if exam result ratification status pending
    if ((examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_RatificationStatus__c) === mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.pendingRatification &&
        (examAuth === null || examAuth === void 0 ? void 0 : examAuth.status) !== mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE &&
        (examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_Status__c) !== mxp_schemas_1.PearsonVue.ExamResultStatus.noShow) {
        examAuthorization.examAuthStatus = mxp_schemas_1.SalesforceResponses.ExamAuthStatus.CONSUMED_RESULT_NOT_PUBLISHED;
        return examAuthorization;
    }
    // exam result pass and ratified
    if ((examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_Status__c) === mxp_schemas_1.PearsonVue.ExamResultStatus.pass &&
        (examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_RatificationStatus__c) === mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.ratified &&
        ![
            mxp_schemas_1.PearsonVue.ExamResultOverrideStatus.misconduct,
            mxp_schemas_1.PearsonVue.ExamResultOverrideStatus.technicalError,
            mxp_schemas_1.PearsonVue.ExamResultOverrideStatus.voided,
        ].includes(examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_OverrideStatus__c)) {
        performUsedExamCredit(baseExamAuth, examAuthorization, log);
        examAuthorization.examAuthStatus = mxp_schemas_1.SalesforceResponses.ExamAuthStatus.CONSUMED_PASSING_EXAM;
        return (0, exports.authorizeExam)(baseExamAuth, examAuthorization, candidate, subscriptionEndDate, subscriptionStartDate);
    }
    // exam result taken
    if ((examAuth === null || examAuth === void 0 ? void 0 : examAuth.status) !== mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE &&
        (examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_Status__c) === mxp_schemas_1.PearsonVue.ExamResultStatus.taken) {
        // not sure which status
        return examAuthorization;
    }
    // exam result fail ,no show, nda refused and malpractice, ratified result
    if (activeExamBookingOrResultWaiting(baseExamAuth.examAuth) &&
        [
            mxp_schemas_1.PearsonVue.ExamResultStatus.fail,
            mxp_schemas_1.PearsonVue.ExamResultStatus.noShow,
            mxp_schemas_1.PearsonVue.ExamResultStatus.ndaRefused,
            mxp_schemas_1.PearsonVue.ExamResultStatus.malpractise,
        ].includes(examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_Status__c) &&
        (examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_RatificationStatus__c) === mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.ratified) {
        performUsedExamCredit(baseExamAuth, examAuthorization, log);
        examAuthorization.examAuthStatus = isExamAuthLocked(candidate === null || candidate === void 0 ? void 0 : candidate.qualificationLevelStatus, mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE);
    }
    // if booking confirmed
    if ((examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c) === mxp_schemas_1.SalesforceResponses.ExamStatus.Active) {
        // Trigger from pathway switch
        if ((operationType === 'Delete' && (examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c) === mxp_schemas_1.SalesforceResponses.ExamStatus.Active) ||
            !((_a = examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_ExamKey__r) === null || _a === void 0 ? void 0 : _a.SFS_EXM_LearningPathway__c.includes(candidate.selectedPathway))) {
            examAuthorization.examBookingCancelActions.push({
                examBookingId: examBooking === null || examBooking === void 0 ? void 0 : examBooking.Id,
                clientCandidateID: candidate.clientCandidateId,
                registrationID: examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_PvBookingId__c,
                reason: `Exam is not part of customer pathway! / Qualification level Status ${candidate === null || candidate === void 0 ? void 0 : candidate.qualificationLevelStatus}`,
            });
        }
        else {
            pvExamAuth.forEach((pvExamAuthItem) => {
                // revoke all active exams
                if (pvExamAuthItem.status === mxp_schemas_1.PearsonVue.EXAM_AUTH_STATUS.ACTIVE) {
                    examAuthorization.eadAction.push(Object.assign(Object.assign({ examAuthID: examAuth.id, pvExamAuthId: pvExamAuthItem === null || pvExamAuthItem === void 0 ? void 0 : pvExamAuthItem.id, authCount: 1, authorizationID: pvExamAuthItem.authorizationId }, (pvExamAuthItem.clientAuthorizationId
                        ? { clientAuthorizationID: pvExamAuthItem.clientAuthorizationId }
                        : null)), { authorizationTransactionType: mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE, clientCandidateID: candidate.clientCandidateId, eligibilityApptDateFirst: examAuth.startDate, eligibilityApptDateLast: examAuth.endDate, examDelivery: pvExamAuthItem.examDelivery, examSeriesCode: pvExamAuthItem.examSeriesCode }));
                }
            });
            // No active exam credit found
            if (!examCredit.find(ec => {
                return ec.status === mxp_schemas_1.SalesforceResponses.ExamCreditStatus.Available;
            })) {
                if ((_b = pvExamAuth.find((pvExamAuthItem) => {
                    if (pvExamAuthItem.status === 'Consumed') {
                        return isExamBookingExistOnPvEAD(pvExamAuthItem, examBooking);
                    }
                })) === null || _b === void 0 ? void 0 : _b.hasCredit) {
                    if ((examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c) === mxp_schemas_1.SalesforceResponses.ExamStatus.Active) {
                        examAuthorization.examBookingCancelActions.push({
                            examBookingId: examBooking === null || examBooking === void 0 ? void 0 : examBooking.Id,
                            clientCandidateID: candidate.clientCandidateId,
                            registrationID: examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_PvBookingId__c,
                            reason: 'No Exam Credit',
                        });
                    }
                    return examAuthorization;
                }
            }
            examAuthorization.examAuthStatus =
                examBooking.SFS_EXB_ExamDeliveryFormat__c === mxp_schemas_1.User.ExamDeliveryFormat.TestCenter
                    ? mxp_schemas_1.SalesforceResponses.ExamAuthStatus.USED_IN_CENTRE_BOOKING
                    : mxp_schemas_1.SalesforceResponses.ExamAuthStatus.USED_ON_VUE_BOOKING;
            return examAuthProcess(candidate, baseExamAuth, examList, examAuthorization, examAuth, examCredit, examCreditJunction, specialAccommodation, specialAccommodationJunction, subscriptionEndDate, subscriptionStartDate);
        }
    }
    // if booking No show and NDA
    if (activeExamBookingOrResultWaiting(baseExamAuth.examAuth) &&
        [mxp_schemas_1.SalesforceResponses.ExamStatus.No_Show, mxp_schemas_1.SalesforceResponses.ExamStatus.NDA_Refuse].includes(examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c)) {
        performUsedExamCredit(baseExamAuth, examAuthorization, log);
        examAuthorization.examAuthStatus = isExamAuthLocked(candidate === null || candidate === void 0 ? void 0 : candidate.qualificationLevelStatus, mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE);
    }
    // if booking cancelled
    if (activeExamBookingOrResultWaiting(baseExamAuth.examAuth) &&
        (examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c) === mxp_schemas_1.SalesforceResponses.ExamStatus.Cancelled) {
        examAuthorization.examAuthStatus = isExamAuthLocked(candidate === null || candidate === void 0 ? void 0 : candidate.qualificationLevelStatus, mxp_schemas_1.SalesforceResponses.ExamAuthStatus.ACTIVE);
    }
    // if booking delivered and exam result pending ratification and hold, no attempt to reauthorize user
    if ((examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c) === mxp_schemas_1.SalesforceResponses.ExamStatus.Delivered &&
        [
            mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.pendingRatification,
            mxp_schemas_1.PearsonVue.ExamResultRatificationStatus.onHold,
        ].includes(examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_RatificationStatus__c)) {
        examAuthorization.examAuthStatus = mxp_schemas_1.SalesforceResponses.ExamAuthStatus.CONSUMED_RESULT_NOT_PUBLISHED;
        return examAuthorization;
    }
    return examAuthProcess(candidate, baseExamAuth, examList, examAuthorization, examAuth, examCredit, examCreditJunction, specialAccommodation, specialAccommodationJunction, subscriptionEndDate, subscriptionStartDate);
};
exports.examAuthEngine = examAuthEngine;
// Authorize/Deauthorize user to sit an exams
const authorizeExam = (baseExamAuth, examAuthorization, candidate, subscriptionEndDate, subscriptionStartDate) => {
    var _a, _b, _c;
    const { examAuth, examCredit, specialAccommodation, examList, examBooking, examResult } = baseExamAuth;
    examAuthorization.personSpecialAccommodationExamAuthJunctionActions = [];
    const isExtend = (0, moment_timezone_1.default)().diff(examAuth.endDate, 'days') > -200;
    // make sure to remove once exam is passed
    if (examAuthorization.examAuthStatus === mxp_schemas_1.SalesforceResponses.ExamAuthStatus.CONSUMED_PASSING_EXAM) {
        examAuthorization.operation = mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE;
    }
    const examListHandler = examList === undefined || examList.length === 0
        ? []
        : examList.filter((exam) => {
            return exam.subject === examAuth.examSubject && exam.pvExamSeriesCode;
        });
    // Delete old Revoked PV EADs that match the no-show/NDA-refuse booking
    // to prevent duplicate authorizations in PearsonVue
    if ([mxp_schemas_1.SalesforceResponses.ExamStatus.No_Show, mxp_schemas_1.SalesforceResponses.ExamStatus.NDA_Refuse].includes(examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c)) {
        (_a = examAuth.pvExamAuth) === null || _a === void 0 ? void 0 : _a.forEach((pvExamAuthItem) => {
            if (pvExamAuthItem.status === mxp_schemas_1.PearsonVue.EXAM_AUTH_STATUS.REVOKED &&
                pvExamAuthItem.authorizationId &&
                isExamBookingExistOnPvEAD(pvExamAuthItem, examBooking)) {
                examAuthorization.eadAction.push(Object.assign(Object.assign({ examAuthID: examAuth.id, pvExamAuthId: pvExamAuthItem === null || pvExamAuthItem === void 0 ? void 0 : pvExamAuthItem.id, authCount: 1, authorizationID: pvExamAuthItem.authorizationId }, (pvExamAuthItem.clientAuthorizationId
                    ? { clientAuthorizationID: pvExamAuthItem.clientAuthorizationId }
                    : null)), { authorizationTransactionType: mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE, clientCandidateID: candidate.clientCandidateId, eligibilityApptDateFirst: examAuth.startDate, eligibilityApptDateLast: examAuth.endDate, examDelivery: pvExamAuthItem.examDelivery, examSeriesCode: pvExamAuthItem.examSeriesCode }));
            }
        });
    }
    for (const exam of examListHandler) {
        const pvExamAuth = (_b = examAuth.pvExamAuth) === null || _b === void 0 ? void 0 : _b.find((item) => {
            return (
            // Will not reuse if results came
            isResultsNotExistOnPvEAD(item, examResult) &&
                ((['Active', 'Consumed'].includes(item.status) && item.examDelivery === exam.deliveryFormat) ||
                    // if exam booking exist with this status, reused for PV Exam Auth request
                    ([mxp_schemas_1.SalesforceResponses.ExamStatus.Cancelled].includes(examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c) &&
                        isExamBookingExistOnPvEAD(item, examBooking))) &&
                item.examKeyId === exam.id);
        });
        // if no pvExamAuth records, no need to delete
        // if exam booking is active no need to process
        if ((examAuthorization.operation === mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE &&
            examAuth.pvExamAuth.length === 0) ||
            (examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c) === mxp_schemas_1.SalesforceResponses.ExamStatus.Active) {
            return examAuthorization;
        }
        // FLP: the sync must only ever move the End Date forward on renewal — the Start Date is set once
        // at creation and must never be reset to the (possibly renewed) subscription start or to today.
        const eligibilityApptDateFirst = subscriptionEndDate
            ? examAuth.startDate
            : isExtend
                ? (0, moment_timezone_1.default)().format('YYYY-MM-DD')
                : examAuth.startDate;
        const { eligibilityApptDateLast, examSeriesCode, examKey } = getEligibilityApptDateLastAndExamSeriesCode(examAuth, exam, isExtend, subscriptionEndDate);
        examAuthorization.authorizeDate = {
            eligibilityApptDateFirst,
            eligibilityApptDateLast,
        };
        const deletePvExamAuthSpecialAccommodation = (pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.currentSpecialAccommodation)
            ? pvExamAuth.currentSpecialAccommodation
                .filter((saj) => {
                return !Boolean(specialAccommodation.find((sa) => {
                    return (sa.personSpecialAccommodationKey === saj.personSpecialAccommodationKey &&
                        exam.examType === sa.examType);
                }));
            })
                .map((saj) => {
                return {
                    id: saj.id,
                    action: 'Delete',
                    pvExamAuthId: saj.pvExamAuthId,
                    personSpecialAccommodationKey: saj.personSpecialAccommodationKey,
                    currentExamDelivery: exam.deliveryFormat,
                };
            })
            : [];
        const createPvExamAuthSpecialAccommodation = specialAccommodation
            ? specialAccommodation
                .filter((sa) => {
                var _a;
                return !((_a = pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.currentSpecialAccommodation) === null || _a === void 0 ? void 0 : _a.map((saj) => saj.personSpecialAccommodationKey).includes(sa.personSpecialAccommodationKey));
            })
                .map((sa) => {
                if ([mxp_schemas_1.SalesforceResponses.ApplicableExamType.ALL, examAuth.examType].includes(sa.examType) &&
                    isExamSeriesAtSpecialAccommodation(sa, examAuth.examSubject, examList, candidate === null || candidate === void 0 ? void 0 : candidate.selectedPathway, exam.deliveryFormat) &&
                    (pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.id)) {
                    return {
                        action: 'Create',
                        pvExamAuthId: pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.id,
                        personSpecialAccommodationKey: sa.personSpecialAccommodationKey,
                        currentExamDelivery: exam.deliveryFormat,
                    };
                }
            })
                .filter((a) => {
                return a !== undefined;
            })
            : [];
        examAuthorization.personSpecialAccommodationExamAuthJunctionActions =
            examAuthorization.personSpecialAccommodationExamAuthJunctionActions.concat(deletePvExamAuthSpecialAccommodation
                ? deletePvExamAuthSpecialAccommodation.concat(createPvExamAuthSpecialAccommodation)
                : createPvExamAuthSpecialAccommodation);
        //
        const authorizationTransactionType = (pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.authorizationId) && examAuthorization.operation === 'Add'
            ? 'Update'
            : examAuthorization.operation === 'Update' && (pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.authorizationId) === undefined
                ? 'Add'
                : examAuthorization.operation;
        if (!((pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.authorizationId) === undefined &&
            authorizationTransactionType === mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE) &&
            !((pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.status) === 'Revoked' && authorizationTransactionType === mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE)) {
            examAuthorization.eadAction.push(Object.assign(Object.assign({ examAuthID: examAuth.id, pvExamAuthId: pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.id, authCount: 1, authorizationID: pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.authorizationId }, ((pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.clientAuthorizationId) ? { clientAuthorizationID: pvExamAuth.clientAuthorizationId } : null)), { authorizationTransactionType: isExamCurrentUsersPathway(exam, candidate === null || candidate === void 0 ? void 0 : candidate.selectedPathway)
                    ? authorizationTransactionType === mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.ADD &&
                        isPvEADNoShowOrNdaRefused(pvExamAuth, examBooking)
                        ? mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.UPDATE
                        : authorizationTransactionType
                    : mxp_schemas_1.PearsonVue.EAD_AUTH_TRANSACTION_TYPE.DELETE, clientCandidateID: candidate.clientCandidateId, eligibilityApptDateFirst,
                eligibilityApptDateLast, examDelivery: exam.deliveryFormat, examKey,
                examSeriesCode, accommodationCode: specialAccommodation === null || specialAccommodation === void 0 ? void 0 : specialAccommodation.map((item) => {
                    if ([mxp_schemas_1.SalesforceResponses.ApplicableExamType.ALL, examAuth.examType].includes(item.examType) &&
                        isExamSeriesAtSpecialAccommodation(item, examAuth.examSubject, examList, candidate === null || candidate === void 0 ? void 0 : candidate.selectedPathway, exam.deliveryFormat)) {
                        return {
                            id: item.id,
                            personSpecialAccommodation: item.personSpecialAccommodationKey,
                            code: item.code,
                            examDelivery: exam.deliveryFormat,
                        };
                    }
                }).filter(item => {
                    return item !== undefined;
                }).filter(item => {
                    return (item === null || item === void 0 ? void 0 : item.code) !== undefined;
                }), 
                // if exam auth key matches the exam credit surely CREDIT100
                examCredit: (_c = examCredit === null || examCredit === void 0 ? void 0 : examCredit.find((item) => {
                    var _a;
                    if (item.status === mxp_schemas_1.SalesforceResponses.ExamCreditStatus.Available &&
                        (0, moment_timezone_1.default)(item.expiryDate).isAfter((0, moment_timezone_1.default)())) {
                        return (item.examSubject === examAuth.examSubject && ((_a = examAuthorization === null || examAuthorization === void 0 ? void 0 : examAuthorization.examCreditAction) === null || _a === void 0 ? void 0 : _a.id) !== item.examCreditId);
                    }
                })) === null || _c === void 0 ? void 0 : _c.examCreditId }));
        }
    }
    return examAuthorization;
};
exports.authorizeExam = authorizeExam;
const getEligibilityApptDateLastAndExamSeriesCode = (examAuth, exam, isExtend, subscriptionEndDate) => {
    var _a, _b;
    const examSeriesCode = exam.pvExamSeriesCode;
    const examKey = exam.id;
    let pvExamAuthCount = 0;
    // only add if its revoked and consumed
    pvExamAuthCount = (_b = (_a = examAuth.pvExamAuth) === null || _a === void 0 ? void 0 : _a.filter((pv) => {
        return (pv.examSubjectId === exam.subject &&
            [mxp_schemas_1.PearsonVue.EXAM_AUTH_STATUS.CONSUMED, mxp_schemas_1.PearsonVue.EXAM_AUTH_STATUS.REVOKED].includes(pv.status));
    })) === null || _b === void 0 ? void 0 : _b.length;
    let eligibilityApptDateLast = (isExtend ? (0, moment_timezone_1.default)().add(365, 'days') : (0, moment_timezone_1.default)(examAuth.endDate))
        .add(pvExamAuthCount, 'days')
        .format('YYYY-MM-DD');
    // FLP: always set PearsonVue EAD end date to subscription end date
    if (subscriptionEndDate) {
        const subscriptionEnd = (0, moment_timezone_1.default)(subscriptionEndDate, 'YYYY-MM-DD', true);
        if (subscriptionEnd.isValid()) {
            eligibilityApptDateLast = subscriptionEnd.format('YYYY-MM-DD');
        }
    }
    return { eligibilityApptDateLast, examSeriesCode, examKey };
};
const performUsedExamCredit = (baseExamAuth, examAuthorization, log) => {
    const { examAuth, examCredit, examResult, examBooking } = baseExamAuth;
    const { pvExamAuth } = examAuth;
    const pvAuth = pvExamAuth === null || pvExamAuth === void 0 ? void 0 : pvExamAuth.find((item) => {
        return isExamBookingExistOnPvEAD(item, examBooking) || isExamResultExistOnPvEAD(item, examResult);
    });
    log.debug('performUsedExamCredit');
    log.debug(`pvAuth : ${pvAuth}`);
    log.debug(`exam credit: ${examCredit}`);
    // Only transition exam credit from Active to Used
    if ((pvAuth === null || pvAuth === void 0 ? void 0 : pvAuth.examCreditId) &&
        examCredit.find((ec) => {
            return ec.examCreditId === (pvAuth === null || pvAuth === void 0 ? void 0 : pvAuth.examCreditId) && ec.status === mxp_schemas_1.SalesforceResponses.ExamCreditStatus.Available;
        })) {
        log.debug(`Used exam credit : ${pvAuth.examCreditId} as used`);
        examAuthorization.examCreditAction = {
            id: pvAuth.examCreditId,
            status: mxp_schemas_1.SalesforceResponses.ExamCreditStatus.Used,
        };
    }
    return examAuthorization;
};
const isResultsNotExistOnPvEAD = (item, examResult) => {
    var _a, _b;
    return ((item === null || item === void 0 ? void 0 : item.authorizationId) !== ((_a = examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_ExamBookingKey__r) === null || _a === void 0 ? void 0 : _a.SFS_EXB_vueAuthorizationID__c) ||
        (item === null || item === void 0 ? void 0 : item.clientAuthorizationId) !== ((_b = examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_ExamBookingKey__r) === null || _b === void 0 ? void 0 : _b.SFS_EXB_SiebelAuthorizationID__c));
};
const isExamBookingExistOnPvEAD = (item, examBooking) => {
    const { authorizationId, clientAuthorizationId } = item;
    // if revoked do not repurpose
    if (item.status === 'Revoked' && [mxp_schemas_1.SalesforceResponses.ExamStatus.Cancelled].includes(examBooking.SFS_EXB_Status__c)) {
        return false;
    }
    return authorizationId
        ? authorizationId === (examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_vueAuthorizationID__c)
        : false || clientAuthorizationId
            ? clientAuthorizationId === (examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_SiebelAuthorizationID__c)
            : false;
};
const isExamResultExistOnPvEAD = (item, examResult) => {
    var _a, _b;
    const { authorizationId, clientAuthorizationId } = item;
    return authorizationId
        ? authorizationId === ((_a = examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_ExamBookingKey__r) === null || _a === void 0 ? void 0 : _a.SFS_EXB_vueAuthorizationID__c)
        : false || clientAuthorizationId
            ? clientAuthorizationId === ((_b = examResult === null || examResult === void 0 ? void 0 : examResult.SFS_EXR_ExamBookingKey__r) === null || _b === void 0 ? void 0 : _b.SFS_EXB_SiebelAuthorizationID__c)
            : false;
};
const isExamSeriesAtSpecialAccommodation = (item, examSubject, examList, learningPathway, deliveryFormat = mxp_schemas_1.User.ExamDeliveryFormat.All) => {
    if (item.examSeriesCode === undefined || item.examSeriesCode === null || item.examSeriesCode.length === 0) {
        return true;
    }
    return (examList
        .filter((ex) => {
        var _a;
        return (ex.subject === examSubject &&
            ((_a = ex.learningPathway) === null || _a === void 0 ? void 0 : _a.includes(learningPathway)) &&
            [mxp_schemas_1.User.ExamDeliveryFormat.All, ex.deliveryFormat].includes(deliveryFormat));
    })
        .filter(e => {
        var _a;
        return (_a = item.examSeriesCode) === null || _a === void 0 ? void 0 : _a.includes(e.pvExamSeriesCode);
    }).length > 0);
};
const isExamCurrentUsersPathway = (exam, pathway) => {
    var _a;
    return (_a = exam === null || exam === void 0 ? void 0 : exam.learningPathway) === null || _a === void 0 ? void 0 : _a.includes(pathway);
};
const activeExamBookingOrResultWaiting = (examAuth) => {
    return [
        mxp_schemas_1.SalesforceResponses.ExamAuthStatus.USED_ON_VUE_BOOKING,
        mxp_schemas_1.SalesforceResponses.ExamAuthStatus.USED_IN_CENTRE_BOOKING,
        mxp_schemas_1.SalesforceResponses.ExamAuthStatus.CONSUMED_RESULT_NOT_PUBLISHED,
    ].includes(examAuth.status);
};
// is pv ead no show or nda refused
const isPvEADNoShowOrNdaRefused = (pvExamAuth, examBooking) => {
    if (pvExamAuth) {
        if ([mxp_schemas_1.SalesforceResponses.ExamStatus.No_Show, mxp_schemas_1.SalesforceResponses.ExamStatus.NDA_Refuse].includes(examBooking === null || examBooking === void 0 ? void 0 : examBooking.SFS_EXB_Status__c) &&
            isExamBookingExistOnPvEAD(pvExamAuth, examBooking)) {
            return true;
        }
    }
    return false;
};
const examAuthProcess = (candidate, baseExamAuth, examList, examAuthorization, examAuth, examCredits, examCreditJunctions, specialAccommodation, specialAccommodationJunction, subscriptionEndDate, subscriptionStartDate) => {
    const deleteArray = examCreditJunctions
        ? examCreditJunctions
            .filter((ejc) => {
            return !Boolean(examCredits.find((ec) => {
                return ec.examCreditId === ejc.examCreditKey;
            }));
        })
            .map((ecj) => {
            return { id: ecj.id, action: 'Delete', examCreditKey: ecj.examCreditKey, examAuthKey: ecj.examAuthKey };
        })
        : [];
    const createArray = examCredits
        ? examCredits
            .filter((ec) => {
            var _a;
            return !((_a = examAuth.examCreditJunction) === null || _a === void 0 ? void 0 : _a.map((ecj) => ecj.examCreditKey).includes(ec.examCreditId));
        })
            .map((ec) => {
            return { action: 'Create', examCreditKey: ec.examCreditId, examAuthKey: ec.examAuthId };
        })
        : [];
    examAuthorization.examCreditJunctionActions = deleteArray ? deleteArray.concat(createArray) : createArray;
    const deleteJunction = specialAccommodationJunction
        ? specialAccommodationJunction
            .filter((saj) => {
            return !Boolean(specialAccommodation.find((sa) => {
                return (sa.personSpecialAccommodationKey === saj.personSpecialAccommodationKey &&
                    examAuth.examType === sa.examType);
            }));
        })
            .map((saj) => {
            return {
                id: saj.id,
                action: 'Delete',
                examAuthKey: saj.examAuthId,
                personSpecialAccommodationKey: saj.personSpecialAccommodationKey,
            };
        })
        : [];
    const createJunction = specialAccommodation
        ? specialAccommodation
            .filter((sa) => {
            return !(specialAccommodationJunction === null || specialAccommodationJunction === void 0 ? void 0 : specialAccommodationJunction.map((saj) => saj.personSpecialAccommodationKey).includes(sa.personSpecialAccommodationKey));
        })
            .map((sa) => {
            if ([mxp_schemas_1.SalesforceResponses.ApplicableExamType.ALL, examAuth.examType].includes(sa.examType) &&
                isExamSeriesAtSpecialAccommodation(sa, examAuth.examSubject, examList, candidate === null || candidate === void 0 ? void 0 : candidate.selectedPathway)) {
                return {
                    action: 'Create',
                    examAuthKey: examAuth.id,
                    personSpecialAccommodationKey: sa.personSpecialAccommodationKey,
                };
            }
        })
            .filter((a) => {
            return a !== undefined;
        })
        : [];
    examAuthorization.examSpecialAccommodationJunctionActions = deleteJunction
        ? deleteJunction.concat(createJunction)
        : createJunction;
    return (0, exports.authorizeExam)(baseExamAuth, examAuthorization, candidate, subscriptionEndDate, subscriptionStartDate);
};
const isExamAuthLocked = (pqlStatus, examAuthStatus) => {
    if (pqlStatus === mxp_schemas_1.User.QualificationLevelStatus.Exempted) {
        return mxp_schemas_1.SalesforceResponses.ExamAuthStatus.EXEMPTED;
    }
    return [
        mxp_schemas_1.User.QualificationLevelStatus.Suspended,
        mxp_schemas_1.User.QualificationLevelStatus.Locked,
        mxp_schemas_1.User.QualificationLevelStatus.NotApplicable,
    ].includes(pqlStatus)
        ? mxp_schemas_1.SalesforceResponses.ExamAuthStatus.LOCKED
        : examAuthStatus;
};
//# sourceMappingURL=index.js.map